import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import CtaBanner from "../components/common/CtaBanner";
import { workProcess } from "../data/content";

export default function WorkProcess() {
  return (
    <>
      <PageHeader title="Work Process" crumbs={[{ label: "Work Process" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="How It Works"
            title="Book Your Taxi in <span>4 Easy Steps</span>"
            text="Getting where you need to go has never been simpler."
          />
          <div className="grid grid-4 process-grid">
            {workProcess.map((p, i) => (
              <div className="process-card" key={i}>
                <span className="process-step">{p.step}</span>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
